<template>
    <div class="share">
        <div class="background-img" ref="background"></div>
        <div style="background:rgba(0,0,0,.6);width:100%;height:100%">
        <div class="share_head">
            <div class="left">
                <img src="./share_img/logo.png" width="41px" height="41px" style="border-radius:50%;flex:1" alt="">
                <div class="text" style="color:#d5d5d5;font-size:14px;margin-left:4px;width:80px">歡樂語音</div>
                <div class="text1" style="color:#d5d5d5;font-size:11px;margin-left:4px;width:182px">免費在線K歌連麥交友平台</div>
            </div>
            <div class="center">
                
            </div>
            <div class="right">
                <input type="text" v-model="this.url" style="display:none">
                <div class="right-content"  @click="doCopy">
                   分享到FB
                </div>
            </div>
        </div>
        <div class="disk_needle">
            <img src="./share_img/yuandian.png" class="yuandian" width="30px" height="auto" alt="">
            <img src="./share_img/needle.e84a701.png" :class="{'active':isActive}"  class="shoubi" width="80px" height="130px" alt="">
        </div>
        <div class="share_body" >
           <div class="scroll-bar" >
               <input type="range" min="0" :max="ProMax" :value="proValue"  class="play-bar" step="0" 
               @touchmove="onmousemove"
               @click="onclick"
                >
           </div>
            <div class="music-background" 
            ref="body" >

                <audio src="" ref="audio" ></audio>
                <div class="box-background" :class="{'rotate':isrotate}">
                    <img :src="UserAvater" alt="">
                </div>
                    <img  @click="play"  v-show="start"
                    ref="start" :class="{'start':start}"
                    src="./share_img/play.png" style="width:55px;height:55px;position:absolute;top:50%;margin-top:-27.5px;
                    left:50%;margin-left:-27.5px" alt="">
                    <img   @click="play" v-show="!start" 
                    ref="start" :class="{'start':!start}"
                    src="./share_img/stop.png" style="width:55px;height:55px;position:absolute;top:50%;margin-top:-27.5px;
                    left:50%;margin-left:-27.5px" alt="">
            </div>

            <div class="music-word">
                 <p>{{songName}}</p>
            </div>
        </div>

        <footer class="footer">
            <div class="share-btn" style="color:#ffffff" @click="gotoroom">
                打開歡樂語音
            </div>
            
            <!-- <div class="silder-area">
                <img src="./share_img/silder.png" style="width:14px;height:10px" alt="">
                    上劃查看評論
            </div> -->
        </footer>
        </div>
    </div>
</template>

<script>
export default {
  name: 'share',
  data () {
    return {
        UserAvater:'',
        songName:' ',
        isActive: false,
        start: true,
        isrotate: false,
        id:'',
        User_img:'',
        Music_mp3:'',
        url:'',
        copytext:'',
        musicLength:'',
        proValue:0,
        ProMax:100,
        timer:''
    }
  },
  mounted () {
    var url = window.location.href
    this.url = url
    var obj = this.getParams(url);
    this.id = obj.id
    this.$axios.get(`../api/api.php?c=song._getSong&id=${this.id}`).then(res=>{
          this.Music_mp3 = res.data.data.mp3
          this.User_img = res.data.data.photo
          this.UserAvater = res.data.data.headImage
          this.songName = res.data.data.name
          this.$refs.background.style.background = `url(${this.UserAvater}) `
          this.$refs.background.style.backgroundSize = `cover`
          this.$refs.audio.src = this.Music_mp3
    })
  },
  methods: {
      play () {
          if (this.proValue >= this.ProMax) {
              this.proValue = 0
          }
          this.musicLength = this.$refs.audio.duration
          this.ProMax = this.$refs.audio.duration
          this.isActive = !this.isActive
          this.start = !this.start
          if (!this.start) {
              this.isrotate = true
              this.$refs.audio.play()
              this.timer = setInterval(() => {
                  this.proValue++
                  if (this.proValue >= this.musicLength) {
                      clearInterval(this.timer)
                      this.isrotate = false
                      this.isActive =  false
                      this.start = true
                  }
              }, 1000)

          }else{
              this.isrotate = false
              this.$refs.audio.pause()
              clearInterval(this.timer)
          }
      },
          getParams(url){
                //获取？后面第一个字符串的索引
                var index = url.indexOf('?')+1;
                //取得url后面的字符串name=zs&age=18&b=2
                var params = url.substr(index);
                //使用&切割字符串，返回一个数组
                var arr = params.split('&');
                //定义一个空对象
                var o = {};
                //数组中每一项的样子 key=value
                for(var i = 0;i < arr.length;i++){
                    //临时数组
                    var tmpArr = arr[i].split('=');
                    var key = tmpArr[0];
                    var value = tmpArr[1];
                    o[key] = value;
                }
                return o;
      },
    doCopy() {
        let copytext = this.url
        this.$copyText( copytext ).then(function (e) {
            alert('複製成功，請到fb分享')
            }, function (e) {
        })
    },
    onmousemove (e) {
        clearInterval(this.timer)
        let timenow = this.$refs.audio.currentTime
        const width =  document.body.clientWidth
        const widthX = width / this.musicLength
        const x = parseInt(e.changedTouches[0].clientX) /  widthX
        this.$refs.audio.currentTime = x
        this.proValue = x
        this.timer = setInterval(() => {
                  this.proValue++
                  if (this.proValue >= this.musicLength) {
                      clearInterval(this.timer)
                      this.isrotate = false
                      this.isActive =  false
                      this.start = true
                  }
              }, 1000)
      },
      onclick (e) {
          clearInterval(this.timer)
          const width =  document.body.clientWidth
          const widthX = width / this.musicLength
          const x = parseInt(e.clientX) /  widthX
          console.log(x)
          this.$refs.audio.currentTime = x
            this.proValue = x
            this.timer = setInterval(() => {
                    this.proValue++
                    if (this.proValue >= this.musicLength) {
                        clearInterval(this.timer)
                        this.isrotate = false
                        this.isActive =  false
                        this.start = true
                    }
            }, 1000)
      },
      gotoroom () {
        if (this._isMobile()) {
           this.isIosorAndroid ()
         } else {
            gtag('event', 'view_promotion', {
            promotion_name: "share_music_jump_pc"
             })
            _hmt.push(['_trackEvent', 'share_music','pc', 'pc'])
            window.location.href="../api/jump.php?targer=pc"
         }
      },
      _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
     },
     isIosorAndroid () {
        const u = navigator.userAgent, app = navigator.appVersion
        //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isiOS) {
           gtag('event', 'view_promotion', {
            promotion_name: "share_music_jump_ios"
            })
            _hmt.push(['_trackEvent', 'share_music','ios', 'ios_app'])
            window.location.href='../api/jump.php?targer=ios'
        } else {
            gtag('event', 'view_promotion', {
            promotion_name: "share_music_jump_android"
            })
            _hmt.push(['_trackEvent', 'share_music','android', 'android_app'])
            window.location.href='../api/jump.php?targer=android'
        }
     }
    }
}
</script>

<style lang="stylus" scoped>
input[type=range]::-webkit-slider-thumb {  
    -webkit-appearance: none;/*清除系统默认样式*/  
    height:7px;/*拖动块高度*/  
    width:  7px;/*拖动块宽度*/  
    background: #fff;/*拖动块背景*/ 
    border-radius:  50%; /*外观设置为圆形*/  
    border: solid 1px #ddd; /*设置边框*/  
}
.rotate
    animation-play-state: running  !important
.share
    position:absolute
    top:0
    left:0
    z-index:-2
    width:100%
    height:100%
    background:rgba(0,0,0,.6)
    .background-img
        position:absolute
        z-index:-8
        width:100%
        height:100%
        background-size:cover
        filter:blur(10px)
    .share_head
        display:flex
        width:100%
        height:9.6rem
        .left
            position:relative
            flex:5
            img
                position:absolute
                top:50%
                margin-top:-20.5px
                left:50%
                margin-left:-42.5px
            .text
                position:absolute
                top:50%
                margin-top:-18.5px
                left:51%
                margin-left:-42.5px
            .text1
                width:333px
                position:absolute
                top:49%
                margin-top:5.5px
                left:51%
                margin-left:-42.5px
        .center
            flex:5
            display:flex
            justify-content:center
            align-items:center
            font-size:1.8rem
            color:#ffffff
        .right
            flex:5
            display:flex
            justify-content:center
            align-items:center
            .right-content
                border-radius:2px
                width:60px
                height:20px
                background:#1278F3
                display:flex
                justify-content:center
                align-items:center
                font-size:0.9rem
                color:#ffffff
    .disk_needle
        position:absolute
        left:50%
        margin-left:-50px
        top:9.9rem
        transform:translate3d(62px,0px,0px)
        z-index:2
        .yuandian
            position:absolute
            top:-3px
            z-index:3
        .shoubi
            position:absolute
            margin-left:36px
            top:-38px
            transform:rotateZ(-37deg)
            z-index:1
            transition:all 1s
        .active
            margin-left:1px
            top:1px
            transform:rotateZ(8deg)
    .share_body
        width:100%
        overflow:hidden
        .scroll-bar
            position:absolute
            width:100%
            height:1px
            background:hsla(0,0%,98%,.4)
            border-radius:.01px
            .play-bar
                position:absolute
                left:0
                top:0
                width:100%
                height:0px
                -webkit-appearance: none;/*清除系统默认样式*/ 
                border-radius:.01px
                background:hsla(0,0%,98%,0)
        .ProgressBar >>>.vue-simple-progress
            height:1px
        .white-box
            z-index:1
            position:relative
            top:63px
            width:250px
            height:250px
            margin:0 auto
            border-radius:50%
            border:2px solid rgb(99,89,74)
            background:rgb(99,89,74)
            .black-box
                width:246px
                height:246px
                position:absolute
                top:50%
                margin-top:-123px
                left:50%
                margin-left:-123px
                background:rgb(12,12,12)
                border-radius:50%
                .pic
                    position:absolute
                    top:50%
                    margin-top:-75px
                    width:150px
                    height:150px
                    border-radius:50%
                    left:50%
                    margin-left:-75px
                    img
                        width:150px
                        height:150px
                        border-radius:50%
                        text-align:center
        .music-background
            width:100%
            height:284px
            margin:30px auto 0
            position:relative
            .box-background
                width:289px
                height:289px
                margin:0 auto
                background:url('./share_img/background.png') no-repeat center center
                background-size: 289px 289px
                animation drops 25s linear infinite forwards   
                @keyframes drops  {
                    0% {
                        transform:rotate(0deg)
                    }
                    50% {
                        transform:rotate(180deg)
                    }
                    100% {
                        transform:rotate(360deg)
                    }
                }
                animation-play-state: paused
                img
                    position:absolute
                    top:50%
                    margin-top:-75px
                    left:50%
                    margin-left:-75px
                    width:150px
                    height:150px
                    border-radius:50%
        .music-word
            height:60px
            width:100%
            margin-top:33px
            text-align:center
            font-size:20px
            line-height:30px
            color:#ffffff
    .footer
        width:100%
        position:relative
        .share-btn
            position:absolute
            width:171px
            height:41px
            text-align:center
            line-height:41px
            font-size:15px
            border-radius:2px
            background:#438dc8
            left:50%
            margin-left:-85.5px
        .silder-area
            font-size:12px
            color:#989690
            height:21px
            margin:20px auto
            text-align:center
</style>